module.exports = __webpack_public_path__ + "img/swap-horizontal.73b9ec12.svg";